import { useMemo } from "react";
import { useLocation } from "react-router-dom";

interface IUseNicheTooltip {
  position: number;
  isDismissNicheTooltip: boolean;
  isVisible: boolean;
}

export const useNicheTooltip = ({
  position,
  isDismissNicheTooltip,
  isVisible
}: IUseNicheTooltip): boolean => {
  const location = useLocation();
  const isOnNichePage = useMemo(() => location.pathname.includes("/niche"), [location.pathname]);
  const isShowNicheTooltip = useMemo(
    () => position === 2 && isOnNichePage && !isDismissNicheTooltip && isVisible,
    [position, isOnNichePage, isDismissNicheTooltip, isVisible]
  );

  return isShowNicheTooltip;
};
